export default "__VITE_ASSET__372cd925__"